module.exports = __webpack_public_path__ + "static/media/lsc_top2.b3f7cd99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/lsc/lsc_top2.svg
// module id = 439
// module chunks = 0